<script>import { cn } from "../../utils/twClnm.js";
export let value = "";
</script>

<textarea
	{...$$restProps}
	class={cn(
		'w-full h-[178px] py-15 px-15 gap-10 rounded-lg border border-gray-300 bg-white font-inter text-sm font-medium leading-[21px] text-left',
		$$restProps.class
	)}
	bind:value
	on:input
/>

